import * as C from "@/components";
import { CustomizationBlocks } from "./CustomizationBlocks";
import { CustomizationButton } from "./CustomizationButton";
import { CustomizationHeader } from "./CustomizationHeader";

export const EuropeanLanderCustomizationSection = () => {
  return (
    <C.PageSection>
      <CustomizationHeader />
      <CustomizationBlocks />
      <CustomizationButton />
    </C.PageSection>
  );
};
